import * as PIXI from 'pixi.js';

class HUEShifter {
    constructor() {
        this.canvas = null;
        this.ctx = null;
    }

    shift(hue, asset) {
        this.canvas = document.createElement('canvas');
        this.ctx = this.canvas.getContext('2d');
        this.canvas.width = asset.image.width;
        this.canvas.height = asset.image.height;
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.ctx.filter = `hue-rotate(${hue}deg)`;
        this.ctx.drawImage(asset.image.baseTexture.source, 0, 0, this.canvas.width, this.canvas.height);
        return PIXI.Texture.fromCanvas(this.canvas, asset.image.baseTexture.scaleMode);
    }
}

export default new HUEShifter();
